import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dbrkvv2d4: FaireProductEntity = {
  token: "p_9dbrkvv2d4",
  type: "product",
  name: "Song Bird Candles – 100% Pure Beeswax – Hand-Crafted",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/a0606abf732339ddf3cff5305fc116e0b9c98ab664eb5df65e4fc8c4c0cdc394.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e813f115a91e877dc60febb50bab7ea93cc867517771fb9d2dd87e97281f4951.png",
    "https://cdn.faire.com/fastly/9b413dfc980d5fec30363f22b3ff66bf62abf10fe0fe0b0e6ad3fa098c98ba09.png",
    "https://cdn.faire.com/fastly/afa179b257e20a69d1428faa2f17ad4dd9f99700dac8b3f80a3be19ea1e90488.jpeg",
    "https://cdn.faire.com/fastly/850c70b8e0db365a2767a65d12a42761e48c56781aeb90d209ad7464981a619a.jpeg",
    "https://cdn.faire.com/fastly/89584ceefb6a7d1864dc52a508b1b155714cb9d4c91a2d20d18a8710abe02ba5.jpeg",
  ],
  priceDollars: 6,
  description:
    'Bring a touch of nature indoors with our Beeswax Song Bird Novelty Candles. Hand-sculpted and cast by Big Dipper Wax Works artisans, these charming birds are crafted from 100% pure beeswax, offering a clean, long-lasting burn with a naturally sweet honey aroma. Perfect for spring décor, romantic settings, or eco-friendly gifts, each bird is available in two delightful poses: Upright and Pecking. Display them together for a playful arrangement or individually as a nature-inspired accent.\n\nProduct Details:\n\n-Burn Time: 20+ hours per bird\n-Dimensions: 3" tall x 4" wide\n-Wax: 100% pure beeswax with natural honey scent\n-Wick: Cotton, paraffin-free\n\nUsage: Eco-Friendly Gifts, Table Décor, Garden Parties, Home Accents, Wedding Favors\n\nNotes: Hand-Crafted, Sustainable, Non-Toxic, Paraffin-Free, Soy-Free, Lead-Free, Hypoallergenic\n\nLearn more at BigDipperWaxWorks.com.',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:52.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
